module.exports = __webpack_public_path__ + "static/media/RS.1c61dd6d.png";